import React, { useState } from 'react';
import {
	Toolbar,
	AppBar,
	Typography,
	Menu,
	MenuItem,
	Fade,
	Button,
} from '@material-ui/core';

import useStyles from './styles';

const Navbar = () => {
	const classes = useStyles();

	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);

	const handleClick = event => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<>
			<AppBar className={classes.navbar} position="fixed">
				<Toolbar>
					<img
						className={classes.logo}
						src="https://res.cloudinary.com/duoforkpp/image/upload/v1623540363/Marv%27s%20Bakery/marvs-bakery-logo_guc2k1.png"
						alt={<Typography>Marv's Bakery</Typography>}
					/>
				</Toolbar>

				<Button
					variant="contained"
					className={classes.menuButton}
					aria-controls="fade-menu"
					aria-haspopup="true"
					onClick={handleClick}
				>
					Menu
				</Button>
				<Menu
					id="fade-menu"
					anchorEl={anchorEl}
					keepMounted
					open={open}
					onClose={handleClose}
					TransitionComponent={Fade}
				>
					<a
						style={{
							textDecoration: 'none',
							color: '#0f0f0f',
						}}
						href="#products"
					>
						<MenuItem color="primary" onClick={handleClose}>
							Productos
						</MenuItem>
					</a>
					<a
						style={{
							textDecoration: 'none',
							color: '#0f0f0f',
						}}
						href="#specialities"
					>
						<MenuItem color="primary" onClick={handleClose}>
							Especialidades
						</MenuItem>
					</a>
					<a
						style={{
							textDecoration: 'none',
							color: '#0f0f0f',
						}}
						href="#aboutUs"
					>
						<MenuItem color="primary" onClick={handleClose}>
							Acerca de
						</MenuItem>
					</a>
				</Menu>
			</AppBar>
		</>
	);
};

export default Navbar;
